import React from 'react';
import '../styles/ContactUs.css';
import appStore from '../assets/appstore.png';
import Seo from '../components/Seo';

function ContactUs() {
  return (
    <div className="contact-us-page">
      <Seo
        title="Contact Chartmaxx AI | AI Trading Chart Analysis App"
        description="Contact Chartmaxx AI for questions about the AI trading chart analysis app for forex, crypto, stocks, commodities, and indices."
        path="/contact"
      />
      <h2>Contact Us</h2>
      <p>If you have any questions, feel free to reach out to us at </p>
      <p><a target='_blank' href='mailto:contact@chartmaxxapp.com' rel="noreferrer">contact@chartmaxxapp.com</a></p>
      <p><a target='_blank' href='https://www.instagram.com/chartmaxxapp' rel="noreferrer">Instagram</a></p>
      <p><a target='_blank' href='https://www.tiktok.com/chartmaxxapp' rel="noreferrer">TikTok</a></p>
      <button><a href="https://apps.apple.com/se/app/balatro/id6502451661?l=en-GB" target="_blank" className="cta" rel="noreferrer">
        <img src={appStore} alt="Logo" className="logo" />
      </a></button>
    </div>
  );
}

export default ContactUs;
